<div>
  @if (orderDetails$ | async; as orderDetails) {
  <div class="d-block d-lg-flex mt-1 justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3">
      <div class="d-lg-flex d-block">
        <div>
          @if (firstBasketItem$ | async; as firstBasketItem) { @switch (firstBasketItem.ItemType) { @case
          (basketItemType.ResaleTicket) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'resale.ticket.purchase.success' | translate,
                        message: 'resale.ticket.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @case (basketItemType.TopUpMember) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'membership.topup.purchase.success' | translate,
                        message: 'membership.topup.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @case (basketItemType.Reward) {
          <ng-container *ngTemplateOutlet="rewardsTemplate; context: { $implicit: firstBasketItem }"></ng-container>
          } @case (basketItemType.PortalProduct) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'products.purchase.success' | translate,
                        message: 'products.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @case (basketItemType.CardToken) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'card.token.purchase.success' | translate,
                        message: 'card.token.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @case (basketItemType.Junior) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'junior.membership.purchase.success' | translate,
                        message: 'junior.membership.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @case (basketItemType.Benefit) {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'benefit.purchase.success' | translate,
                        message: 'benefit.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } @default {
          <ng-container
            *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'default.purchase.success' | translate,
                        message: 'default.purchase.email.confirmation' | translate,
                      }
                    "
          ></ng-container>
          } } }

          <div class="d-flex justify-content-between border-0 mt-4">
            <a class="btn btn-primary confirm-btn fw-bold" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>

        <div class="border rounded payment-details">
          @if (basketItems$ | async; as basketItems) { @if (basketItems.length > 0) { @for (basket of basketItems; track
          basket.BasketKind) { @for (item of basket.Items; track item.Id) {
          <div class="d-lg-flex d-block">
            <div class="me-4">
              <img
                class="purchase-success-image rounded"
                src="{{ item.Image | contentImage : '7' : 'marketplace' }}"
                alt="{{ item.Image }}"
                [useDefault]="true"
                loyaltyType="marketplace"
                draggable="false"
              />
            </div>
            <div class="mt-3 mt-lg-0">
              <ng-container>
                <div class="font-size-14 fw-bold mb-3">
                  {{ item.Title || 'Display Name' }}
                </div>
              </ng-container>

              <!--Quantity-->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.quantity' | translate }}</span>
                <span class="fw-bold font-size-14">{{ item.Quantity }}</span>
              </div>
              <!--Merchant-->
              @if (item.Merchant > 0) {
              <div class="mb-2 mt-2 d-flex align-items-center flex-row">
                <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.merchant.used' | translate }}</span>
                <span class="fw-bold pe-2 font-size-14">
                  @if (basket.Items.length === 1) {
                  {{ orderDetails.TotalAmount / 100 | FortressCurrencyPipe }}
                  @if (orderDetails.TaxAmount > 0) { ({{ 'marketplace.tax.included' | translate }}) } } @else {
                  {{ item.Merchant / 100 | FortressCurrencyPipe }}
                  }
                </span>
              </div>
              } @else {
              <!--Ecash-->
              @if (item.Ecash > 0) {
              <div class="col-6">
                <div class="mb-2 d-flex align-items-center">
                  <span class="mt-2 font-size-12">{{ 'marketplace.ecash.used' | translate }}</span>
                </div>
              </div>
              <div class="col-6">
                <div class="mb-2 d-flex align-items-center">
                  <span class="font-size-14 pe-2 fw-bold">{{ item.Ecash / 100 | FortressCurrencyPipe }}</span>
                </div>
              </div>
              } @else {
              <!-- Points -->
              <div class="d-flex align-items-center mt-2">
                <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.points.used' | translate }}</span>
                <span *ngIf="item.Points > 0" class="fw-bold font-size-14"
                  >{{ item.Points / 100 | number }} {{ 'fgbcl.currency.pts' | translate }}</span
                >
                <span *ngIf="item.Points == 0" class="fw-bold font-size-14">
                  {{ 'fgbcl.marketplace.item.free' | translate }}</span
                >
              </div>
              } }
            </div>
          </div>
          } } } @else {
          <div class="text-center m-5">{{ 'no.purchased.item.found' | translate }}</div>
          } }
        </div>
      </div>
    </div>
  </div>
  }
</div>

<!-- Generic Message Template -->
<ng-template #messageTemplate let-title="title" let-message="message">
  <div class="text-success mb-0 fw-bold font-size-18 text-left">
    {{ title }}
  </div>
  <p class="mb-0 text-black font-size-14 text-left pe-lg-4 rewards-success-description">
    {{ message }}
  </p>
</ng-template>

<!-- Rewards Template -->
<ng-template #rewardsTemplate let-reward>
  @switch (reward.SubItemType) { @case (marketplaceSubType.MarketplaceItem) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'marketplace.purchase.success' | translate,
            message: 'marketplace.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } @case (marketplaceSubType.UniqueCode) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'unique.code.purchase.success' | translate,
            message: 'unique.code.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } @case (marketplaceSubType.DownloadLink) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'download.purchase.success' | translate,
            message: 'download.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } @case (marketplaceSubType.Event) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'events.purchase.success' | translate,
            message: 'events.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } @case (marketplaceSubType.MerchantItem) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'merchant.item.purchase.success' | translate,
            message: 'merchant.item.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } @case (marketplaceSubType.VirtualEvent) {
  <ng-container
    *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'virtual.event.purchase.success' | translate,
            message: 'virtual.event.purchase.email.confirmation' | translate,
          }
        "
  ></ng-container>
  } }
</ng-template>
